export default __webpack_public_path__ + "static/media/trac_4.d7c15613.png";